import { createApp } from 'vue'
import InterviewProfessionals from './InterviewProfessionals.vue'
import router from './router';

if (process.env.NODE_ENV != "production") {
    import("../../breakmoods/public/css/output.css");
}

createApp(InterviewProfessionals).use(router).mount('#platform')
